/** @jsxImportSource @emotion/react */
import React from 'react';
import { Box } from '@mui/material';
import CurrentPlan from './CurrentPlan';
import BasicInfo from './BasicInfo';
import AgentSeats from './AgentSeats';
import WABAassigned from './WABAassigned';
import ConfigureMarkup from './ConfigureMarkup';

const ProfileInfoBody = () => {
  return (
    <Box display={'flex'} flexDirection={'column'} gap={'20px'}>
      <CurrentPlan />
      <ConfigureMarkup />
      <BasicInfo />
      <AgentSeats />
      <WABAassigned />
    </Box>
  );
};

export default ProfileInfoBody;
